import { SuperAdminLogin } from '@/components/SuperAdminLogin';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/components/auth/AuthContext';
import { useEffect } from 'react';
import { toast } from 'sonner';

export default function SuperAdminLoginPage() {
  const navigate = useNavigate();
  const { user, isAuthenticated, loading, signOut } = useAuth();

  const normalizeRole = (r?: string | null): string => {
    const v = String(r || '').toLowerCase();
    if (v === 'jobseeker') return 'job_seeker';
    if (v === 'superadmin') return 'super_admin';
    return v;
  };

  // If already authenticated, redirect based on user type
  useEffect(() => {
    if (!loading && isAuthenticated && user) {
      const userType = normalizeRole(user.user_type || '');
      
      if (userType === 'super_admin') {
        navigate('/super-admin/dashboard', { replace: true });
      } else if (userType === 'admin') {
        navigate('/super-admin/dashboard', { replace: true });
      } else if (userType === 'job_seeker' || userType === 'employer') {
        toast.error('Access Denied: This page is restricted to Super Administrators only.');
        const targetPath = userType === 'job_seeker' ? '/jobseeker-dashboard' : '/employer/dashboard';
        navigate(targetPath, { replace: true });
      }
    }
  }, [loading, isAuthenticated, user, navigate, signOut]);

  const handleLogin = (loggedInUser: any) => {
    // Validate that only super_admin can login here
    const userType = normalizeRole(loggedInUser?.user_type || '');
    if (loggedInUser && userType !== 'super_admin') {
      console.log(' Non-super-admin attempted to login via super admin page');
      toast.error('Access Denied: Only Super Administrators can login here.');
      signOut();
      setTimeout(() => {
        navigate('/auth');
      }, 1500);
      return;
    }
    // Let AuthContext and useEffect handle the redirect
  };

  const handleBackToWebsite = () => {
    navigate('/');
  };

  return (
    <SuperAdminLogin 
      onLogin={handleLogin}
      onBackToWebsite={handleBackToWebsite}
    />
  );
}
